import { render } from "./Header.vue?vue&type=template&id=2cd8de1f&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2cd8de1f&scoped=true&lang=css"

import exportComponent from "/Users/nikita/Documents/works/novofamil/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd8de1f"]])

export default __exports__